import apiClient from '../apiClient';
import { GET_TRANSPORTATION_PROFILE_EXPORT_DATA_URL } from '../apiUrl';

const getExportTransportationProfileApi = () => {
  return apiClient.get(GET_TRANSPORTATION_PROFILE_EXPORT_DATA_URL);
};

export default getExportTransportationProfileApi;
